import { Select } from 'components/Select'
import { LABELS, PLACEHOLDERS } from 'constants/txt'
import useAdditionalInfo from 'features/ContractDetails/ContractDetailsGeneral/ContractDetailsAdditionalInfo/hooks/useAdditionalInfo'
import { Props } from './types'
import './styles.scss'

const AdditionalInfoForm = ({ form, handleChangeForm }: Props) => {
  const {
    vendorOptions,
    contractStewardOptions,
    vendorContractStewardDisabled
  } = useAdditionalInfo({ form })

  return (
    <div className="row gap-24">
      <Select
        options={vendorOptions}
        propsItem={{
          name: 'vendor',
          label: LABELS.VENDOR,
          rules: [
            {
              required: true,
              message: 'Required'
            }
          ]
        }}
        propsSelect={{
          placeholder: PLACEHOLDERS.PLEASE_SELECT,
          onChange: handleChangeForm
        }}
      />
      <Select
        options={contractStewardOptions}
        propsItem={{
          name: 'vendor_contract_steward',
          label: LABELS.VENDOR_CONTRACT_STEWARD
        }}
        propsSelect={{
          placeholder: PLACEHOLDERS.PLEASE_SELECT,
          disabled: vendorContractStewardDisabled,
          onChange: handleChangeForm
        }}
      />
    </div>
  )
}

export default AdditionalInfoForm
